import { Component, OnInit } from '@angular/core';
import { NoticeService, Notice } from '../notice-service';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'app-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss']
})
export class NoticeComponent extends BaseComponent implements OnInit {

  constructor(
    private noticeService : NoticeService
  ) { 
    super();
  }

  init() {
    this.notices = this.noticeService.dequeueNotices();
    this.subscribe(this.noticeService.dismissed, () => {
      this.notices = [];
    });
  }
  
  notices : Notice[];
}
